// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useParams } from "react-router-dom";
// import { useLocation } from "react-router-dom";


// // ✅ Replace with your actual API Gateway base URL
// const API_BASE = "https://241hbdvql1.execute-api.ap-south-1.amazonaws.com/praud";

// const AdminDashboard = () => {
//   const { orgId } = useParams(); // we pass orgId in route like /dashboard/ORG123
//   const [tiles, setTiles] = useState([]);
//   const [form, setForm] = useState({ title: "", link: "", imageUrl: "", description: "" });
//   const [editingTileId, setEditingTileId] = useState(null);
//   const [message, setMessage] = useState("");

//   // ✅ Fetch tiles for this OrgId
//   const fetchTiles = useCallback(async () => {
//     try {
//       const res = await axios.get(`${API_BASE}/orgs/${orgId}`);
//       setTiles(res.data); // API already returns tiles array
//     } catch (err) {
//       console.error("Error fetching tiles:", err);
//       showMessage("❌ Could not fetch tiles from the server.");
//     }
//   }, [orgId]);

//   useEffect(() => {
//     fetchTiles();
//   }, [fetchTiles]);

//   // Handle form input changes
//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   // Display messages temporarily
//   const showMessage = (msg) => {
//     setMessage(msg);
//     setTimeout(() => setMessage(""), 4000);
//   };

//   // ✅ Create or Update a tile
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (editingTileId) {
//         // update
//         await axios.put(`${API_BASE}/orgs/${orgId}/tiles/${editingTileId}`, form);
//         showMessage("✅ Tile updated successfully!");
//       } else {
//         // create
//         await axios.post(`${API_BASE}/tiles`, { OrgId: orgId, ...form });
//         showMessage("✅ Tile created successfully!");
//       }
//       setForm({ title: "", link: "", imageUrl: "", description: "" });
//       setEditingTileId(null);
//       fetchTiles();
//     } catch (err) {
//       console.error("Error saving tile:", err);
//       showMessage("❌ Error saving tile.");
//     }
//   };

//   // ✅ Delete a tile
//   const handleDelete = async (tileId) => {
//     if (!window.confirm("Are you sure you want to delete this tile?")) return;
//     try {
//       await axios.delete(`${API_BASE}/orgs/${orgId}/tiles/${tileId}`);
//       showMessage("✅ Tile deleted!");
//       fetchTiles();
//     } catch (err) {
//       console.error("Error deleting tile:", err);
//       showMessage("❌ Error deleting tile.");
//     }
//   };

//   // Prefill form for editing
//   const handleEdit = (tile) => {
//     setForm({
//       title: tile.title,
//       link: tile.link,
//       imageUrl: tile.imageUrl,
//       description: tile.description || "",
//     });
//     setEditingTileId(tile.tileId);
//     window.scrollTo(0, 0);
//   };

//   return (
//     <div style={{ maxWidth: "800px", margin: "auto", padding: "2rem", fontFamily: "Arial, sans-serif" }}>
//       <h2>Organizer: {orgId}</h2>
//       <h3>Manage Linked Event Tiles</h3>

//       {/* Form */}
//       <form
//         onSubmit={handleSubmit}
//         style={{
//           marginBottom: "2rem",
//           padding: "1.5rem",
//           border: "1px solid #ddd",
//           borderRadius: "8px",
//           background: "#f9f9f9",
//         }}
//       >
//         <h3>{editingTileId ? "Edit Tile" : "Create New Tile"}</h3>

//         <input
//           type="text"
//           name="title"
//           placeholder="Title"
//           value={form.title}
//           onChange={handleChange}
//           required
//           style={{ width: "100%", padding: "0.7rem", marginBottom: "0.7rem" }}
//         />
//         <input
//           type="url"
//           name="link"
//           placeholder="Link"
//           value={form.link}
//           onChange={handleChange}
//           required
//           style={{ width: "100%", padding: "0.7rem", marginBottom: "0.7rem" }}
//         />
//         <input
//           type="url"
//           name="imageUrl"
//           placeholder="Image URL"
//           value={form.imageUrl}
//           onChange={handleChange}
//           required
//           style={{ width: "100%", padding: "0.7rem", marginBottom: "0.7rem" }}
//         />
//         <input
//           type="text"
//           name="description"
//           placeholder="Description"
//           value={form.description}
//           onChange={handleChange}
//           style={{ width: "100%", padding: "0.7rem", marginBottom: "1rem" }}
//         />

//         <button
//           type="submit"
//           style={{
//             padding: "0.7rem 1.5rem",
//             background: "#8B1538",
//             color: "white",
//             border: "none",
//             borderRadius: "8px",
//             cursor: "pointer",
//           }}
//         >
//           {editingTileId ? "Update Tile" : "Create Tile"}
//         </button>
//         {editingTileId && (
//           <button
//             type="button"
//             onClick={() => setEditingTileId(null) || setForm({ title: "", link: "", imageUrl: "", description: "" })}
//             style={{ marginLeft: "1rem", padding: "0.7rem 1.5rem", background: "#6c757d", color: "white", border: "none", borderRadius: "8px" }}
//           >
//             Cancel Edit
//           </button>
//         )}
//       </form>

//       {/* Message */}
//       {message && (
//         <p
//           style={{
//             padding: "1rem",
//             borderRadius: "8px",
//             background: message.includes("❌") ? "#f8d7da" : "#d4edda",
//             color: message.includes("❌") ? "#721c24" : "#155724",
//           }}
//         >
//           {message}
//         </p>
//       )}

//       {/* Tiles */}
//       <h3>Existing Tiles</h3>
//       <div>
//         {tiles.length > 0 ? (
//           tiles.map((tile) => (
//             <div
//               key={tile.tileId}
//               style={{
//                 display: "flex",
//                 gap: "1rem",
//                 alignItems: "center",
//                 border: "1px solid #ccc",
//                 padding: "1rem",
//                 marginBottom: "1rem",
//                 borderRadius: "8px",
//               }}
//             >
//               <img
//                 src={tile.imageUrl}
//                 alt={tile.title}
//                 style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "4px" }}
//               />
//               <div style={{ flex: 1 }}>
//                 <h4 style={{ marginTop: 0 }}>{tile.title}</h4>
//                 <p style={{ margin: 0 }}>
//                   <a href={tile.link} target="_blank" rel="noopener noreferrer">
//                     {tile.link}
//                   </a>
//                 </p>
//                 <p style={{ margin: "0.5rem 0", color: "#333" }}>{tile.description || "No description"}</p>
//                 <small style={{ color: "#666" }}>ID: {tile.tileId}</small>
//               </div>
//               <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
//                 <button
//                   onClick={() => handleEdit(tile)}
//                   style={{ padding: "0.5rem 1rem", cursor: "pointer", background: "#007bff", color: "white", border: "none" }}
//                 >
//                   Edit
//                 </button>
//                 <button
//                   onClick={() => handleDelete(tile.tileId)}
//                   style={{ padding: "0.5rem 1rem", cursor: "pointer", background: "#dc3545", color: "white", border: "none" }}
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           ))
//         ) : (
//           <p>No tiles found. Create one using the form above!</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;

// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useParams, useLocation } from "react-router-dom";
// // API Base
// const API_BASE = "https://241hbdvql1.execute-api.ap-south-1.amazonaws.com/praud";

// const AdminDashboard = () => {
//   const { orgId: paramOrgId } = useParams(); // if URL has /dashboard/:orgId
//   const location = useLocation();
//   const stateOrgId = location.state?.orgName; // orgName passed via navigate state

//   const orgId = paramOrgId || stateOrgId; // use param first, else state

//   const [tiles, setTiles] = useState([]);
//   const [form, setForm] = useState({ title: "", link: "", imageUrl: "", description: "" });
//   const [editingTileId, setEditingTileId] = useState(null);
//   const [message, setMessage] = useState("");
  

//   // Fetch tiles for this OrgId
//   const fetchTiles = useCallback(async () => {
//     if (!orgId) return; // safety check

//     try {
//       const res = await axios.get(`${API_BASE}/orgs/${orgId}`);
//       if (res.data && Array.isArray(res.data)) {
//         setTiles(res.data); // tiles array
//       } else {
//         setTiles([]); // no tiles yet
//       }
//     } catch (err) {
//       console.error("Error fetching tiles:", err);
//       if (err.response && err.response.status === 404) {
//         setTiles([]); // OrgId exists but no tiles
//       } else {
//         showMessage("❌ Could not fetch tiles from the server.");
//       }
//     }
//   }, [orgId]);

//   useEffect(() => {
//     fetchTiles();
//   }, [fetchTiles]);

//   // Prefill OrgId in POST request
//   useEffect(() => {
//     if (orgId) {
//       setForm((prev) => ({ ...prev })); // OrgId is used when posting
//     }
//   }, [orgId]);

//   // Form input change
//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   // Show temporary messages
//   const showMessage = (msg) => {
//     setMessage(msg);
//     setTimeout(() => setMessage(""), 4000);
//   };

//   // Create or Update tile
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!orgId) return showMessage("❌ OrgId is missing.");

//     try {
//       if (editingTileId) {
//         await axios.put(`${API_BASE}/orgs/${orgId}/tiles/${editingTileId}`, form);
//         showMessage("✅ Tile updated successfully!");
//       } else {
//         await axios.post(`${API_BASE}/tiles`, { OrgId: orgId, ...form });
//         showMessage("✅ Tile created successfully!");
//       }
//       setForm({ title: "", link: "", imageUrl: "", description: "" });
//       setEditingTileId(null);
//       fetchTiles();
//     } catch (err) {
//       console.error("Error saving tile:", err);
//       showMessage("❌ Error saving tile.");
//     }
//   };

//   // Delete tile
//   const handleDelete = async (tileId) => {
//     if (!window.confirm("Are you sure you want to delete this tile?")) return;
//     try {
//       await axios.delete(`${API_BASE}/orgs/${orgId}/tiles/${tileId}`);
//       showMessage("✅ Tile deleted!");
//       fetchTiles();
//     } catch (err) {
//       console.error("Error deleting tile:", err);
//       showMessage("❌ Error deleting tile.");
//     }
//   };

//   // Edit tile
//   const handleEdit = (tile) => {
//     setForm({
//       title: tile.title,
//       link: tile.link,
//       imageUrl: tile.imageUrl,
//       description: tile.description || "",
//     });
//     setEditingTileId(tile.tileId);
//     window.scrollTo(0, 0);
//   };

//   return (
//     <div style={{ maxWidth: "800px", margin: "auto", padding: "2rem", fontFamily: "Arial, sans-serif" }}>
//       <h2>Organizer: {orgId || "Unknown"}</h2>
//       <h3>Manage Linked Event Tiles</h3>

//       {/* Form */}
//       <form
//         onSubmit={handleSubmit}
//         style={{ marginBottom: "2rem", padding: "1.5rem", border: "1px solid #ddd", borderRadius: "8px", background: "#f9f9f9" }}
//       >
//         <h3>{editingTileId ? "Edit Tile" : "Create New Tile"}</h3>
//         <input type="text" name="title" placeholder="Title" value={form.title} onChange={handleChange} required style={{ width: "100%", padding: "0.7rem", marginBottom: "0.7rem" }} />
//         <input type="url" name="link" placeholder="Link" value={form.link} onChange={handleChange} required style={{ width: "100%", padding: "0.7rem", marginBottom: "0.7rem" }} />
//         <input type="url" name="imageUrl" placeholder="Image URL" value={form.imageUrl} onChange={handleChange} required style={{ width: "100%", padding: "0.7rem", marginBottom: "0.7rem" }} />
//         <input type="text" name="description" placeholder="Description" value={form.description} onChange={handleChange} style={{ width: "100%", padding: "0.7rem", marginBottom: "1rem" }} />

//         <button type="submit" style={{ padding: "0.7rem 1.5rem", background: "#8B1538", color: "white", border: "none", borderRadius: "8px", cursor: "pointer" }}>
//           {editingTileId ? "Update Tile" : "Create Tile"}
//         </button>
//         {editingTileId && (
//           <button type="button" onClick={() => setEditingTileId(null) || setForm({ title: "", link: "", imageUrl: "", description: "" })} style={{ marginLeft: "1rem", padding: "0.7rem 1.5rem", background: "#6c757d", color: "white", border: "none", borderRadius: "8px" }}>
//             Cancel Edit
//           </button>
//         )}
//       </form>

//       {/* Message */}
//       {message && (
//         <p style={{ padding: "1rem", borderRadius: "8px", background: message.includes("❌") ? "#f8d7da" : "#d4edda", color: message.includes("❌") ? "#721c24" : "#155724" }}>
//           {message}
//         </p>
//       )}

//       {/* Tiles */}
//       <h3>Existing Tiles</h3>
//       <div>
//         {tiles.length > 0 ? (
//           tiles.map((tile) => (
//             <div key={tile.tileId} style={{ display: "flex", gap: "1rem", alignItems: "center", border: "1px solid #ccc", padding: "1rem", marginBottom: "1rem", borderRadius: "8px" }}>
//               <img src={tile.imageUrl} alt={tile.title} style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "4px" }} />
//               <div style={{ flex: 1 }}>
//                 <h4 style={{ marginTop: 0 }}>{tile.title}</h4>
//                 <p style={{ margin: 0 }}>
//                   <a href={tile.link} target="_blank" rel="noopener noreferrer">{tile.link}</a>
//                 </p>
//                 <p style={{ margin: "0.5rem 0", color: "#333" }}>{tile.description || "No description"}</p>
//                 <small style={{ color: "#666" }}>ID: {tile.tileId}</small>
//               </div>
//               <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
//                 <button onClick={() => handleEdit(tile)} style={{ padding: "0.5rem 1rem", cursor: "pointer", background: "#007bff", color: "white", border: "none" }}>Edit</button>
//                 <button onClick={() => handleDelete(tile.tileId)} style={{ padding: "0.5rem 1rem", cursor: "pointer", background: "#dc3545", color: "white", border: "none" }}>Delete</button>
//               </div>
//             </div>
//           ))
//         ) : (
//           <p>No tiles found. Create one using the form above!</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;



// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useParams, useLocation, useNavigate } from "react-router-dom";

// // API Base
// const API_BASE = "https://241hbdvql1.execute-api.ap-south-1.amazonaws.com/praud";

// const AdminDashboard = () => {
//   const { orgId: paramOrgId } = useParams();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const stateOrgId = location.state?.orgName;

//   const orgId = paramOrgId || stateOrgId;

//   const [tiles, setTiles] = useState([]);
//   const [form, setForm] = useState({ title: "", link: "", imageUrl: "", description: "" });
//   const [editingTileId, setEditingTileId] = useState(null);
//   const [message, setMessage] = useState("");

//   // Fetch tiles
//   const fetchTiles = useCallback(async () => {
//     if (!orgId) return;

//     try {
//       const res = await axios.get(`${API_BASE}/orgs/${orgId}`);
//       if (res.data && Array.isArray(res.data)) {
//         setTiles(res.data);
//       } else {
//         setTiles([]);
//       }
//     } catch (err) {
//       console.error("Error fetching tiles:", err);
//       if (err.response && err.response.status === 404) {
//         setTiles([]);
//       } else {
//         showMessage("❌ Could not fetch tiles from the server.");
//       }
//     }
//   }, [orgId]);

//   useEffect(() => {
//     fetchTiles();
//   }, [fetchTiles]);

//   // Show messages
//   const showMessage = (msg) => {
//     setMessage(msg);
//     setTimeout(() => setMessage(""), 4000);
//   };

//   // Handle Generate QR button
//    // AdminDashboard.js
//   // Handle Generate QR button
//   const handleGenerateQr = () => {
//     if (!tiles.length) {
//       showMessage("❌ No tiles found. Please create a tile first!");
//       return;
//     }

//   // Get current origin dynamically
//     const currentOrigin = window.location.origin; // e.g., http://localhost:3008
//     const qrUrl = `${currentOrigin}/user/${orgId}`;

//   // Navigate and pass url in state
//     navigate(`/QrGenerator/${orgId}`, { state: { url: qrUrl } });
//   };



//   // Form input change
//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   // Create or update tile
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!orgId) return showMessage("❌ OrgId is missing.");

//     try {
//       if (editingTileId) {
//         await axios.put(`${API_BASE}/orgs/${orgId}/tiles/${editingTileId}`, form);
//         showMessage("✅ Tile updated successfully!");
//       } else {
//         await axios.post(`${API_BASE}/tiles`, { OrgId: orgId, ...form });
//         showMessage("✅ Tile created successfully!");
//       }
//       setForm({ title: "", link: "", imageUrl: "", description: "" });
//       setEditingTileId(null);
//       fetchTiles();
//     } catch (err) {
//       console.error("Error saving tile:", err);
//       showMessage("❌ Error saving tile.");
//     }
//   };

//   // Delete tile
//   const handleDelete = async (tileId) => {
//     if (!window.confirm("Are you sure you want to delete this tile?")) return;
//     try {
//       await axios.delete(`${API_BASE}/orgs/${orgId}/tiles/${tileId}`);
//       showMessage("✅ Tile deleted!");
//       fetchTiles();
//     } catch (err) {
//       console.error("Error deleting tile:", err);
//       showMessage("❌ Error deleting tile.");
//     }
//   };

//   // Edit tile
//   const handleEdit = (tile) => {
//     setForm({
//       title: tile.title,
//       link: tile.link,
//       imageUrl: tile.imageUrl,
//       description: tile.description || "",
//     });
//     setEditingTileId(tile.tileId);
//     window.scrollTo(0, 0);
//   };

//   return (
//     <div style={{ maxWidth: "900px", margin: "auto", padding: "2rem", fontFamily: "Arial, sans-serif" }}>
//       {/* Header with QR button */}
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//         <h2>Organizer: {orgId || "Unknown"}</h2>
//         <button
//           onClick={handleGenerateQr}
//           style={{
//             padding: "0.6rem 1.2rem",
//             background: "#28a745",
//             color: "white",
//             border: "none",
//             borderRadius: "6px",
//             cursor: "pointer",
//           }}
//         >
//           Generate QR
//         </button>
//       </div>

//       <h3>Manage Linked Event Tiles</h3>

//       {/* Form */}
//       <form
//         onSubmit={handleSubmit}
//         style={{ marginBottom: "2rem", padding: "1.5rem", border: "1px solid #ddd", borderRadius: "8px", background: "#f9f9f9" }}
//       >
//         <h3>{editingTileId ? "Edit Tile" : "Create New Tile"}</h3>
//         <input type="text" name="title" placeholder="Title" value={form.title} onChange={handleChange} required style={{ width: "100%", padding: "0.7rem", marginBottom: "0.7rem" }} />
//         <input type="url" name="link" placeholder="Link" value={form.link} onChange={handleChange} required style={{ width: "100%", padding: "0.7rem", marginBottom: "0.7rem" }} />
//         <input type="url" name="imageUrl" placeholder="Image URL" value={form.imageUrl} onChange={handleChange} required style={{ width: "100%", padding: "0.7rem", marginBottom: "0.7rem" }} />
//         <input type="text" name="description" placeholder="Description" value={form.description} onChange={handleChange} style={{ width: "100%", padding: "0.7rem", marginBottom: "1rem" }} />

//         <button type="submit" style={{ padding: "0.7rem 1.5rem", background: "#8B1538", color: "white", border: "none", borderRadius: "8px", cursor: "pointer" }}>
//           {editingTileId ? "Update Tile" : "Create Tile"}
//         </button>
//         {editingTileId && (
//           <button
//             type="button"
//             onClick={() => setEditingTileId(null) || setForm({ title: "", link: "", imageUrl: "", description: "" })}
//             style={{ marginLeft: "1rem", padding: "0.7rem 1.5rem", background: "#6c757d", color: "white", border: "none", borderRadius: "8px" }}
//           >
//             Cancel Edit
//           </button>
//         )}
//       </form>

//       {/* Message */}
//       {message && (
//         <p style={{ padding: "1rem", borderRadius: "8px", background: message.includes("❌") ? "#f8d7da" : "#d4edda", color: message.includes("❌") ? "#721c24" : "#155724" }}>
//           {message}
//         </p>
//       )}

//       {/* Tiles */}
//       <h3>Existing Tiles</h3>
//       <div>
//         {tiles.length > 0 ? (
//           tiles.map((tile) => (
//             <div key={tile.tileId} style={{ display: "flex", gap: "1rem", alignItems: "center", border: "1px solid #ccc", padding: "1rem", marginBottom: "1rem", borderRadius: "8px" }}>
//               <img src={tile.imageUrl} alt={tile.title} style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "4px" }} />
//               <div style={{ flex: 1 }}>
//                 <h4 style={{ marginTop: 0 }}>{tile.title}</h4>
//                 <p style={{ margin: 0 }}>
//                   <a href={tile.link} target="_blank" rel="noopener noreferrer">
//                     {tile.link}
//                   </a>
//                 </p>
//                 <p style={{ margin: "0.5rem 0", color: "#333" }}>{tile.description || "No description"}</p>
//                 <small style={{ color: "#666" }}>ID: {tile.tileId}</small>
//               </div>
//               <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
//                 <button onClick={() => handleEdit(tile)} style={{ padding: "0.5rem 1rem", cursor: "pointer", background: "#007bff", color: "white", border: "none" }}>
//                   Edit
//                 </button>
//                 <button onClick={() => handleDelete(tile.tileId)} style={{ padding: "0.5rem 1rem", cursor: "pointer", background: "#dc3545", color: "white", border: "none" }}>
//                   Delete
//                 </button>
//               </div>
//             </div>
//           ))
//         ) : (
//           <p>No tiles found. Create one using the form above!</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;


// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import "./AdminDashboard.css"; // Import the stylesheet

// // API Base
// const API_BASE = "https://241hbdvql1.execute-api.ap-south-1.amazonaws.com/praud";

// const AdminDashboard = () => {
//   const { orgId } = useParams();
//   const navigate = useNavigate();

//   const [tiles, setTiles] = useState([]);
//   const [form, setForm] = useState({ title: "", link: "", imageUrl: "", description: "" });
//   const [editingTileId, setEditingTileId] = useState(null);
//   const [message, setMessage] = useState("");
//   const [loading, setLoading] = useState(true);

//   // Fetch tiles
//   const fetchTiles = useCallback(async () => {
//     if (!orgId) return;
//     setLoading(true);
//     try {
//       const res = await axios.get(`${API_BASE}/orgs/${orgId}`);
//       setTiles(Array.isArray(res.data) ? res.data : []);
//     } catch (err) {
//       console.error("Error fetching tiles:", err);
//       setTiles([]);
//       if (!err.response || err.response.status !== 404) {
//         showMessage("❌ Could not fetch tiles from the server.", "error");
//       }
//     } finally {
//       setLoading(false);
//     }
//   }, [orgId]);

//   useEffect(() => {
//     fetchTiles();
//   }, [fetchTiles]);

//   // Show messages with a specific type (success/error)
//   const showMessage = (msg, type = "success") => {
//     setMessage({ text: msg, type });
//     setTimeout(() => setMessage(""), 4000);
//   };

//   // Handle Generate QR button
//   const handleGenerateQr = () => {
//     if (!tiles.length) {
//       showMessage("First create a tile to generate a QR code.", "error");
//       return;
//     }
//     const qrUrl = `${window.location.origin}/user/${orgId}`;
//     navigate(`/QrGenerator/${orgId}`, { state: { url: qrUrl } });
//   };

//   // Form input change
//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const resetForm = () => {
//     setForm({ title: "", link: "", imageUrl: "", description: "" });
//     setEditingTileId(null);
//   };

//   // Create or update tile
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!orgId) return showMessage("❌ OrgId is missing.", "error");

//     try {
//       if (editingTileId) {
//         await axios.put(`${API_BASE}/orgs/${orgId}/tiles/${editingTileId}`, form);
//         showMessage("✅ Tile updated successfully!");
//       } else {
//         await axios.post(`${API_BASE}/tiles`, { OrgId: orgId, ...form });
//         showMessage("✅ Tile created successfully!");
//       }
//       resetForm();
//       fetchTiles();
//     } catch (err) {
//       console.error("Error saving tile:", err);
//       showMessage("❌ Error saving tile.", "error");
//     }
//   };

//   // Delete tile
//   const handleDelete = async (tileId) => {
//     if (!window.confirm("Are you sure you want to delete this tile?")) return;
//     try {
//       await axios.delete(`${API_BASE}/orgs/${orgId}/tiles/${tileId}`);
//       showMessage("✅ Tile deleted!");
//       fetchTiles();
//     } catch (err) {
//       console.error("Error deleting tile:", err);
//       showMessage("❌ Error deleting tile.", "error");
//     }
//   };

//   // Edit tile
//   const handleEdit = (tile) => {
//     setForm({
//       title: tile.title,
//       link: tile.link,
//       imageUrl: tile.imageUrl,
//       description: tile.description || "",
//     });
//     setEditingTileId(tile.tileId);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   return (
//     <div className="dashboard-container">
//       {message.text && (
//         <div className={`message-toast ${message.type === 'error' ? 'error' : 'success'}`}>
//           {message.text}
//         </div>
//       )}

//       <header className="dashboard-header">
//         <div className="header-title">
//           <h1>Admin Dashboard</h1>
//           <span className="org-id-badge">{orgId || "Unknown"}</span>
//         </div>
//         <button className="qr-btn" onClick={handleGenerateQr}>
//           <QrCodeIcon /> Generate QR
//         </button>
//       </header>

//       <main className="dashboard-content">
//         <section className="form-card">
//           <h2>{editingTileId ? "Edit Tile" : "Create New Tile"}</h2>
//           <form onSubmit={handleSubmit} className="tile-form">
//             <div className="form-group">
//               <input type="text" name="title" placeholder="Tile Title" value={form.title} onChange={handleChange} required />
//               <input type="url" name="link" placeholder="https://example.com" value={form.link} onChange={handleChange} required />
//             </div>
//             <div className="form-group">
//               <input type="url" name="imageUrl" placeholder="Image URL (e.g., https://.../image.png)" value={form.imageUrl} onChange={handleChange} required />
//             </div>
//             <div className="form-group">
//               <textarea name="description" placeholder="Short Description" value={form.description} onChange={handleChange} rows="3" />
//             </div>
//             <div className="form-actions">
//               <button type="submit" className="btn-primary">
//                 {editingTileId ? "Update Tile" : "Create Tile"}
//               </button>
//               {editingTileId && (
//                 <button type="button" className="btn-secondary" onClick={resetForm}>
//                   Cancel Edit
//                 </button>
//               )}
//             </div>
//           </form>
//         </section>

//         <section className="tiles-section">
//           <h2>Existing Tiles</h2>
//           {loading ? (
//             <div className="loader"></div>
//           ) : tiles.length > 0 ? (
//             <div className="tiles-list">
//               {tiles.map((tile) => (
//                 <div key={tile.tileId} className="tile-item">
//                   <img src={tile.imageUrl} alt={tile.title} className="tile-image" />
//                   <div className="tile-content">
//                     <h4>{tile.title}</h4>
//                     <p>{tile.description || "No description provided."}</p>
//                     <a href={tile.link} target="_blank" rel="noopener noreferrer">{tile.link}</a>
//                   </div>
//                   <div className="tile-actions">
//                     <button onClick={() => handleEdit(tile)} className="action-btn edit-btn" title="Edit"><EditIcon /></button>
//                     <button onClick={() => handleDelete(tile.tileId)} className="action-btn delete-btn" title="Delete"><DeleteIcon /></button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="empty-state">
//               <p>No tiles found for this organization.</p>
//               <p>Create one using the form above to get started!</p>
//             </div>
//           )}
//         </section>
//       </main>
//     </div>
//   );
// };

// // --- SVG Icons ---
// const QrCodeIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1H3zm2 2H4v1h1V5zm4 0a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1V5zm2 2h1V6h-1v1zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2h1v-1H5v1zm8-4a1 1 0 00-1 1v1h-1v1h2v-1a1 1 0 00-1-1zm-1 3v-1h1v1h-1zm-2-2a1 1 0 011-1h1v2h-2v-1zm4 1h1v1h-1v-1z" clipRule="evenodd" /></svg>);
// const EditIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" /><path fillRule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clipRule="evenodd" /></svg>);
// const DeleteIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" /></svg>);

// export default AdminDashboard;


// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import "./AdminDashboard.css"; // Your existing stylesheet

// // --- DND-Kit Imports ---
// import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
// import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
// import { CSS } from '@dnd-kit/utilities';

// // API Base
// const API_BASE = "https://241hbdvql1.execute-api.ap-south-1.amazonaws.com/praud";

// // --- New Sortable Tile Item Component ---
// // We wrap the tile item in its own component to use the useSortable hook
// const SortableTileItem = ({ tile, handleEdit, handleDelete }) => {
//   const {
//     attributes,
//     listeners,
//     setNodeRef,
//     transform,
//     transition,
//     isDragging,
//   } = useSortable({ id: tile.tileID }); // Ensure you use the correct ID property (tileID from your Python code)

//   // Apply styles for dragging animation and visual feedback
//   const style = {
//     transform: CSS.Transform.toString(transform),
//     transition,
//     zIndex: isDragging ? 10 : 'auto', // Ensure dragging item is on top
//     opacity: isDragging ? 0.8 : 1,
//   };

//   return (
//     <div ref={setNodeRef} style={style} className="tile-item">
//       {/* Drag Handle Icon - This is what the user will click and drag */}
//       <div className="drag-handle" {...attributes} {...listeners} title="Drag to reorder">
//         <DragHandleIcon />
//       </div>
//       <img src={tile.imageUrl} alt={tile.title} className="tile-image" />
//       <div className="tile-content">
//         <h4>{tile.title}</h4>
//         <p>{tile.description || "No description provided."}</p>
//         <a href={tile.link} target="_blank" rel="noopener noreferrer">{tile.link}</a>
//       </div>
//       <div className="tile-actions">
//         <button onClick={() => handleEdit(tile)} className="action-btn edit-btn" title="Edit"><EditIcon /></button>
//         <button onClick={() => handleDelete(tile.tileID)} className="action-btn delete-btn" title="Delete"><DeleteIcon /></button>
//       </div>
//     </div>
//   );
// };


// const AdminDashboard = () => {
//   const { orgId } = useParams();
//   const navigate = useNavigate();

//   const [tiles, setTiles] = useState([]);
//   const [form, setForm] = useState({ title: "", link: "", imageUrl: "", description: "" });
//   const [editingTileId, setEditingTileId] = useState(null);
//   const [message, setMessage] = useState("");
//   const [loading, setLoading] = useState(true);

//   // Fetch tiles
//   const fetchTiles = useCallback(async () => {
//     if (!orgId) return;
//     setLoading(true);
//     try {
//       const res = await axios.get(`${API_BASE}/orgs/${orgId}`);
//       setTiles(Array.isArray(res.data) ? res.data : []);
//     } catch (err) {
//       console.error("Error fetching tiles:", err);
//       setTiles([]);
//       if (!err.response || err.response.status !== 404) {
//         showMessage("❌ Could not fetch tiles from the server.", "error");
//       }
//     } finally {
//       setLoading(false);
//     }
//   }, [orgId]);

//   useEffect(() => {
//     fetchTiles();
//   }, [fetchTiles]);
  
//   // --- New: DND Sensors ---
//   // This helps prevent the drag from starting on an accidental click
//   const sensors = useSensors(
//     useSensor(PointerSensor, {
//       activationConstraint: {
//         distance: 8, // User must drag at least 8px before a drag event starts
//       },
//     })
//   );

//   // --- New: Drag End Handler ---
//   const handleDragEnd = async (event) => {
//     const { active, over } = event;

//     if (active.id !== over.id) {
//       // Find the old and new array indexes of the dragged item
//       const oldIndex = tiles.findIndex((t) => t.tileID === active.id);
//       const newIndex = tiles.findIndex((t) => t.tileID === over.id);
      
//       // Create the newly ordered array for an optimistic UI update
//       const reorderedTiles = arrayMove(tiles, oldIndex, newIndex);
//       setTiles(reorderedTiles);
      
//       // Extract just the tile IDs in the new order
//       const tileIdsInNewOrder = reorderedTiles.map(t => t.tileID);

//       // Call the new backend endpoint to save the sequence
//       try {
//         await axios.put(`${API_BASE}/orgs/${orgId}/tiles/sequence`, {
//             tileIds: tileIdsInNewOrder
//         });
//         showMessage("✅ Sequence updated!");
//       } catch (err) {
//         console.error("Failed to update sequence:", err);
//         showMessage("❌ Failed to save new order. Reverting.", "error");
//         fetchTiles(); // If API fails, revert to original order from server
//       }
//     }
//   };


//   // Show messages with a specific type (success/error)
//   const showMessage = (msg, type = "success") => {
//     setMessage({ text: msg, type });
//     setTimeout(() => setMessage(""), 4000);
//   };

//   // Handle Generate QR button
//   const handleGenerateQr = () => {
//     if (!tiles.length) {
//       showMessage("First create a tile to generate a QR code.", "error");
//       return;
//     }
//     const qrUrl = `${window.location.origin}/user/${orgId}`;
//     navigate(`/QrGenerator/${orgId}`, { state: { url: qrUrl } });
//   };

//   // Form input change
//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const resetForm = () => {
//     setForm({ title: "", link: "", imageUrl: "", description: "" });
//     setEditingTileId(null);
//   };

//   // Create or update tile
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!orgId) return showMessage("❌ OrgId is missing.", "error");

//     try {
//       if (editingTileId) {
//         await axios.put(`${API_BASE}/orgs/${orgId}/tiles/${editingTileId}`, form);
//         showMessage("✅ Tile updated successfully!");
//       } else {
//         await axios.post(`${API_BASE}/tiles`, { OrgId: orgId, ...form });
//         showMessage("✅ Tile created successfully!");
//       }
//       resetForm();
//       fetchTiles();
//     } catch (err) {
//       console.error("Error saving tile:", err);
//       showMessage("❌ Error saving tile.", "error");
//     }
//   };

//   // Delete tile
//   const handleDelete = async (tileId) => {
//     if (!window.confirm("Are you sure you want to delete this tile?")) return;
//     try {
//       await axios.delete(`${API_BASE}/orgs/${orgId}/tiles/${tileId}`);
//       showMessage("✅ Tile deleted!");
//       fetchTiles();
//     } catch (err) {
//       console.error("Error deleting tile:", err);
//       showMessage("❌ Error deleting tile.", "error");
//     }
//   };

//   // Edit tile
//   const handleEdit = (tile) => {
//     setForm({
//       title: tile.title,
//       link: tile.link,
//       imageUrl: tile.imageUrl,
//       description: tile.description || "",
//     });
//     setEditingTileId(tile.tileID); // Use correct ID property
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   return (
//     <div className="dashboard-container">
//       {message.text && (
//         <div className={`message-toast ${message.type === 'error' ? 'error' : 'success'}`}>
//           {message.text}
//         </div>
//       )}

//       <header className="dashboard-header">
//         <div className="header-title">
//           <h1>Admin Dashboard</h1>
//           <span className="org-id-badge">{orgId || "Unknown"}</span>
//         </div>
//         <button className="qr-btn" onClick={handleGenerateQr}>
//           <QrCodeIcon /> Generate QR
//         </button>
//       </header>

//       <main className="dashboard-content">
//         <section className="form-card">
//           <h2>{editingTileId ? "Edit Tile" : "Create New Tile"}</h2>
//           <form onSubmit={handleSubmit} className="tile-form">
//             <div className="form-group">
//               <input type="text" name="title" placeholder="Tile Title" value={form.title} onChange={handleChange} required />
//               <input type="url" name="link" placeholder="https://example.com" value={form.link} onChange={handleChange} required />
//             </div>
//             <div className="form-group">
//               <input type="url" name="imageUrl" placeholder="Image URL (e.g., https://.../image.png)" value={form.imageUrl} onChange={handleChange} required />
//             </div>
//             <div className="form-group">
//               <textarea name="description" placeholder="Short Description" value={form.description} onChange={handleChange} rows="3" />
//             </div>
//             <div className="form-actions">
//               <button type="submit" className="btn-primary">
//                 {editingTileId ? "Update Tile" : "Create Tile"}
//               </button>
//               {editingTileId && (
//                 <button type="button" className="btn-secondary" onClick={resetForm}>
//                   Cancel Edit
//                 </button>
//               )}
//             </div>
//           </form>
//         </section>

//         <section className="tiles-section">
//           <h2>Existing Tiles</h2>
//           {loading ? (
//             <div className="loader"></div>
//           ) : tiles.length > 0 ? (
//             // --- DND-Kit Context Wrappers ---
//             <DndContext 
//               sensors={sensors}
//               collisionDetection={closestCenter}
//               onDragEnd={handleDragEnd}
//             >
//               <SortableContext 
//                 items={tiles.map(t => t.tileID)} // Use correct ID property
//                 strategy={verticalListSortingStrategy}
//               >
//                 <div className="tiles-list">
//                   {tiles.map((tile) => (
//                     <SortableTileItem 
//                         key={tile.tileID} // Use correct ID property
//                         tile={tile}
//                         handleEdit={handleEdit}
//                         handleDelete={handleDelete}
//                     />
//                   ))}
//                 </div>
//               </SortableContext>
//             </DndContext>
//           ) : (
//             <div className="empty-state">
//               <p>No tiles found for this organization.</p>
//               <p>Create one using the form above to get started!</p>
//             </div>
//           )}
//         </section>
//       </main>
//     </div>
//   );
// };

// // --- SVG Icons ---
// const QrCodeIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1H3zm2 2H4v1h1V5zm4 0a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1V5zm2 2h1V6h-1v1zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2h1v-1H5v1zm8-4a1 1 0 00-1 1v1h-1v1h2v-1a1 1 0 00-1-1zm-1 3v-1h1v1h-1zm-2-2a1 1 0 011-1h1v2h-2v-1zm4 1h1v1h-1v-1z" clipRule="evenodd" /></svg>);
// const EditIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" /><path fillRule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clipRule="evenodd" /></svg>);
// const DeleteIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" /></svg>);

// // --- Add New Drag Handle SVG Icon ---
// const DragHandleIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="24" height="24"><path fillRule="evenodd" d="M10 5a1 1 0 011 1v8a1 1 0 11-2 0V6a1 1 0 011-1zM4 9a1 1 0 011 1v.01L5 10a1 1 0 11-2 0V10a1 1 0 011-1zm12 0a1 1 0 011 1v.01L17 10a1 1 0 11-2 0V10a1 1 0 011-1z" clipRule="evenodd" /></svg>);


// export default AdminDashboard;




import React, { useState, useEffect, useCallback, useRef } from "react"; // Added useRef
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./AdminDashboard.css";

// --- DND-Kit Imports ---
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

// API Base
const API_BASE = "https://241hbdvql1.execute-api.ap-south-1.amazonaws.com/praud";

// --- Sortable Tile Item Component (No changes needed here) ---
const SortableTileItem = ({ tile, handleEdit, handleDelete }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: tile.tileID });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 10 : 'auto',
    opacity: isDragging ? 0.8 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className="tile-item">
      <div className="drag-handle" {...attributes} {...listeners} title="Drag to reorder">
        <DragHandleIcon />
      </div>
      <img src={tile.imageUrl} alt={tile.title} className="tile-image" />
      <div className="tile-content">
        <h4>{tile.title}</h4>
        <p>{tile.description || "No description provided."}</p>
        <a href={tile.link} target="_blank" rel="noopener noreferrer">{tile.link}</a>
      </div>
      <div className="tile-actions">
        <button onClick={() => handleEdit(tile)} className="action-btn edit-btn" title="Edit"><EditIcon /></button>
        <button onClick={() => handleDelete(tile.tileID)} className="action-btn delete-btn" title="Delete"><DeleteIcon /></button>
      </div>
    </div>
  );
};


const AdminDashboard = () => {
  const { orgId } = useParams();
  const navigate = useNavigate();

  const [tiles, setTiles] = useState([]);
  const [form, setForm] = useState({ title: "", link: "", imageUrl: "", description: "" });
  const [editingTileId, setEditingTileId] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  // --- New State for File Upload ---
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const fileInputRef = useRef(null); // Ref to trigger file input click

  // Fetch tiles (No changes)
  const fetchTiles = useCallback(async () => {
    if (!orgId) return;
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE}/orgs/${orgId}`);
      setTiles(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Error fetching tiles:", err);
      setTiles([]);
      if (!err.response || err.response.status !== 404) {
        showMessage("❌ Could not fetch tiles from the server.", "error");
      }
    } finally {
      setLoading(false);
    }
  }, [orgId]);

  useEffect(() => {
    fetchTiles();
  }, [fetchTiles]);
  
  // DND Sensors (No changes)
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    })
  );

  // Drag End Handler (No changes)
  const handleDragEnd = async (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = tiles.findIndex((t) => t.tileID === active.id);
      const newIndex = tiles.findIndex((t) => t.tileID === over.id);
      const reorderedTiles = arrayMove(tiles, oldIndex, newIndex);
      setTiles(reorderedTiles);
      const tileIdsInNewOrder = reorderedTiles.map(t => t.tileID);
      try {
        await axios.put(`${API_BASE}/orgs/${orgId}/tiles/sequence`, {
            tileIds: tileIdsInNewOrder
        });
        showMessage("✅ Sequence updated!");
      } catch (err) {
        console.error("Failed to update sequence:", err);
        showMessage("❌ Failed to save new order. Reverting.", "error");
        fetchTiles();
      }
    }
  };

  // Show messages (No changes)
  const showMessage = (msg, type = "success") => {
    setMessage({ text: msg, type });
    setTimeout(() => setMessage(""), 4000);
  };

  // Handle Generate QR (No changes)
  const handleGenerateQr = () => {
    if (!tiles.length) {
      showMessage("First create a tile to generate a QR code.", "error");
      return;
    }
    const qrUrl = `${window.location.origin}/user/${orgId}`;
    navigate(`/QrGenerator/${orgId}`, { state: { url: qrUrl } });
  };

  // Form input change (No changes)
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // --- New: Handler for File Input Change ---
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
      // Clear the imageUrl field if a file is chosen
      setForm(prev => ({ ...prev, imageUrl: "" }));
    } else {
      setImageFile(null);
      showMessage("Please select a valid image file.", "error");
    }
  };


  // --- Updated: Reset form to include file state ---
  const resetForm = () => {
    setForm({ title: "", link: "", imageUrl: "", description: "" });
    setEditingTileId(null);
    setImageFile(null);
    setImagePreview("");
    if(fileInputRef.current) {
        fileInputRef.current.value = ""; // Also reset the file input visually
    }
  };

  // --- Updated: Submit handler with file upload logic ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!orgId) return showMessage("❌ OrgId is missing.", "error");
    
    let finalImageUrl = form.imageUrl;

    // 1. If a new file is uploaded, handle it first
    if (imageFile) {
        try {
            // **IMPORTANT**: You need a backend endpoint for this.
            // This endpoint should take a fileName and fileType and return a presigned URL for S3.
            const presignedRes = await axios.post(`${API_BASE}/generate-presigned-url`, {
                fileName: imageFile.name,
                fileType: imageFile.type,
                orgId: orgId 
            });

            const { uploadUrl, fileUrl } = presignedRes.data;

            // Upload the actual file to the S3 presigned URL
            await axios.put(uploadUrl, imageFile, {
                headers: { 'Content-Type': imageFile.type }
            });
            
            finalImageUrl = fileUrl; // The final public URL of the uploaded image

        } catch (err) {
            console.error("Error uploading image:", err);
            showMessage("❌ Image upload failed. Please try again.", "error");
            return; // Stop if the upload fails
        }
    }
    
    if (!finalImageUrl) {
        showMessage("❌ Please provide an image URL or upload an image file.", "error");
        return;
    }

    const tileData = { ...form, imageUrl: finalImageUrl };

    try {
      if (editingTileId) {
        await axios.put(`${API_BASE}/orgs/${orgId}/tiles/${editingTileId}`, tileData);
        showMessage("✅ Tile updated successfully!");
      } else {
        await axios.post(`${API_BASE}/tiles`, { OrgId: orgId, ...tileData });
        showMessage("✅ Tile created successfully!");
      }
      resetForm();
      fetchTiles();
    } catch (err) {
      console.error("Error saving tile:", err);
      showMessage("❌ Error saving tile.", "error");
    }
  };

  // Delete tile (No changes)
  const handleDelete = async (tileId) => {
    if (!window.confirm("Are you sure you want to delete this tile?")) return;
    try {
      await axios.delete(`${API_BASE}/orgs/${orgId}/tiles/${tileId}`);
      showMessage("✅ Tile deleted!");
      fetchTiles();
    } catch (err) {
      console.error("Error deleting tile:", err);
      showMessage("❌ Error deleting tile.", "error");
    }
  };

  // --- Updated: Edit tile to handle image preview ---
  const handleEdit = (tile) => {
    setForm({
      title: tile.title,
      link: tile.link,
      imageUrl: tile.imageUrl,
      description: tile.description || "",
    });
    setEditingTileId(tile.tileID);
    setImagePreview(tile.imageUrl); // Show existing image as preview
    setImageFile(null); // Clear any staged file from a previous action
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="dashboard-container">
      {message.text && (
        <div className={`message-toast ${message.type === 'error' ? 'error' : 'success'}`}>
          {message.text}
        </div>
      )}

      <header className="dashboard-header">
        <div className="header-title">
          <h1>Admin Dashboard</h1>
          <span className="org-id-badge">{orgId || "Unknown"}</span>
        </div>
        <button className="qr-btn" onClick={handleGenerateQr}>
          <QrCodeIcon /> Generate QR
        </button>
      </header>

      <main className="dashboard-content">
        <section className="form-card">
          <h2>{editingTileId ? "Edit Tile" : "Create New Tile"}</h2>
          <form onSubmit={handleSubmit} className="tile-form">
            <div className="form-group">
              <input type="text" name="title" placeholder="Tile Title" value={form.title} onChange={handleChange} required />
              <input type="url" name="link" placeholder="https://example.com" value={form.link} onChange={handleChange} required />
            </div>

            {/* --- New Image Upload UI --- */}
            <div className="form-group image-upload-section">
                <div className="upload-options">
                    <input 
                        type="url" 
                        name="imageUrl" 
                        placeholder="Paste Image URL" 
                        value={form.imageUrl} 
                        onChange={handleChange} 
                        disabled={!!imageFile} // Disable if a file is selected
                    />
                    <span className="or-divider">OR</span>
                    <button type="button" className="btn-upload" onClick={() => fileInputRef.current.click()}>
                        Upload Image
                    </button>
                    <input 
                        type="file" 
                        ref={fileInputRef} 
                        onChange={handleFileChange}
                        accept="image/png, image/jpeg, image/gif, image/webp"
                        style={{ display: 'none' }} 
                    />
                </div>
                {imagePreview && (
                    <div className="image-preview-container">
                        <img src={imagePreview} alt="Preview" className="image-preview" />
                        {imageFile && (
                            <div className="file-info">
                                <span className="file-name">{imageFile.name}</span>
                                <span className="file-size">{(imageFile.size / 1024).toFixed(2)} KB</span>
                            </div>
                        )}
                    </div>
                )}
            </div>

            <div className="form-group">
              <textarea name="description" placeholder="Short Description" value={form.description} onChange={handleChange} rows="3" />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn-primary">
                {editingTileId ? "Update Tile" : "Create Tile"}
              </button>
              {editingTileId && (
                <button type="button" className="btn-secondary" onClick={resetForm}>
                  Cancel Edit
                </button>
              )}
            </div>
          </form>
        </section>

        <section className="tiles-section">
          <h2>Existing Tiles</h2>
          {loading ? (
            <div className="loader"></div>
          ) : tiles.length > 0 ? (
            <DndContext 
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <SortableContext 
                items={tiles.map(t => t.tileID)}
                strategy={verticalListSortingStrategy}
              >
                <div className="tiles-list">
                  {tiles.map((tile) => (
                    <SortableTileItem 
                        key={tile.tileID}
                        tile={tile}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                    />
                  ))}
                </div>
              </SortableContext>
            </DndContext>
          ) : (
            <div className="empty-state">
              <p>No tiles found for this organization.</p>
              <p>Create one using the form above to get started!</p>
            </div>
          )}
        </section>
      </main>
    </div>
  );
};

// --- SVG Icons (No changes) ---
const QrCodeIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1H3zm2 2H4v1h1V5zm4 0a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1V5zm2 2h1V6h-1v1zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2h1v-1H5v1zm8-4a1 1 0 00-1 1v1h-1v1h2v-1a1 1 0 00-1-1zm-1 3v-1h1v1h-1zm-2-2a1 1 0 011-1h1v2h-2v-1zm4 1h1v1h-1v-1z" clipRule="evenodd" /></svg>);
const EditIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" /><path fillRule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clipRule="evenodd" /></svg>);
const DeleteIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" /></svg>);
const DragHandleIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="24" height="24"><path fillRule="evenodd" d="M10 5a1 1 0 011 1v8a1 1 0 11-2 0V6a1 1 0 011-1zM4 9a1 1 0 011 1v.01L5 10a1 1 0 11-2 0V10a1 1 0 011-1zm12 0a1 1 0 011 1v.01L17 10a1 1 0 11-2 0V10a1 1 0 011-1z" clipRule="evenodd" /></svg>);


export default AdminDashboard;